import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import type { OutcomeRowVM } from './derive';
import { OtherOutcomeCard } from './other-outcome-card';
interface OutcomesTableProps {
  rows: ReadonlyArray<OutcomeRowVM>;
  marketPubkey: string;
}
export function OtherOutcomesTable(t0) {
  const $ = _c(10);
  const {
    rows,
    marketPubkey
  } = t0;
  const t = useTranslations("market.resolvedPanel");
  if (rows.length === 0) {
    return null;
  }
  let t1;
  if ($[0] !== t) {
    t1 = t("tableOutcome");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== marketPubkey || $[3] !== rows) {
    let t3;
    if ($[5] !== marketPubkey) {
      t3 = (row, index) => <OtherOutcomeCard key={row.index} row={row} rank={index + 1} marketPubkey={marketPubkey} />;
      $[5] = marketPubkey;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    t2 = rows.map(t3);
    $[2] = marketPubkey;
    $[3] = rows;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[7] !== t1 || $[8] !== t2) {
    t3 = <ul aria-label={t1} data-testid="resolved-panel-other-outcomes" className="flex min-w-0 flex-col gap-5">{t2}</ul>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}